/**
 * Sektion-Model
 * @class service_v3sSection
 * @memberOf v3sWbtPlayerApp:model
 * @extends v3sWbtPlayerApp:model.service_v3sItem
 */
angular.module('v3sWbtPlayerApp').factory('v3sSection', ["v3sItem", "v3sLog", function (v3sItem, v3sLog) {

    // instantiate the sco object
    var v3sSection = function (data) {

        this.masteryscore = 100;

        // use the original item object constructor
        v3sItem.apply(this, arguments);

        this.children = [];
        this.scoredItems = 0;

        this.updateChildrenRunning = false;
        this.overwriteOnUpdate = true;

        this.childrenIncludeFilter = [];

        if (!!data && this.type === "section") {
            for (var i = 0; i < data.children.length; i++) {
                var item = data.children[i];
                if (item.type === "section") {
                    this.children[i] = new v3sSection(item);
                } else {
                    var page = new v3sItem(item);
                    this.children[i] = page;                  
                }
                this.children[i].parent = this;
            }
            this.updateExercisesCount();
        }
    };

    // use the original v3sItem prototype
    v3sSection.prototype = new v3sItem();

    v3sSection.prototype.updateChildren = function (updateChildrenFunction) {
        try {
            this.updateChildrenRunning = true;
            updateChildrenFunction();
        } catch (e) {
            v3sLog.warn("Exception: ", false, e);
            v3sLog.warn("Could not update children of " + this.id);
        }
        finally {
            this.updateChildrenRunning = false;
            this.update();
        }
    };

    v3sSection.prototype.getChildrenForUpdate = function () {
        var childrenForUpdate = [];

        angular.forEach(this.getChildren(), function (item) {
            if (item.isTrackable()) {
                childrenForUpdate.push(item);
            }
        });

        return childrenForUpdate;
    };


    v3sSection.prototype.update = function () {

        var items = this.getChildrenForUpdate();
        if (!this.updateChildrenRunning && this.isTrackable() && items.length > 0) {

            var newStatus = "";
            var newScore = 0;

            var scoreAll = 0;
            var scored = 0;
            var evaluated = 0;

            var completed = 0;
            var incomplete = 0;

            var self = this;
            angular.forEach(items, function (item) {
                if (item.status == "completed") {
                    completed++;
                } else if (item.status == "incomplete") {
                    incomplete++;
                }

                var scoredData = item.getScoredData();
                scoreAll += scoredData.score;
                scored += scoredData.count;
                evaluated += scoredData.evaluated;
            });

            this.scoredItems = scored;

            if (items.length == completed) {
                newStatus = "completed";
            } else if (incomplete > 0 || completed > 0) {
                newStatus = "incomplete";
            } else {
                newStatus = "not attempted";
            }

            var updated = false;
            if (this.status != newStatus && newStatus != "not attempted" && (this.status != "completed" || this.overwriteOnUpdate)) {
                this.status = newStatus;
                updated = true;
            }

            if (!!this.scoredItems && evaluated > 0) {
                newScore = this.parseScore(scoreAll / this.scoredItems);
                if (this.score != newScore && (!this.score|| this.score < newScore || this.overwriteOnUpdate)) {
                    this.score = newScore;
                    updated = true;
                }            
            }

            if (updated) {
                this.notifyPageChanged();
                this.updateLastAccess();
            }
        }
    };

    v3sSection.prototype.getScoredData = function () {
        var scoredData = { score: 0, count: 0, evaluated: 0 };

        if (this.isTrackable()) {
            scoredData.count = this.getScoredItemsCount();
            scoredData.score = this.getScore() * scoredData.count;
            scoredData.evaluated = this.isEvaluated() ? scoredData.count : 0;
        }

        return scoredData;
    };

    v3sSection.prototype.isScorable = function () {
        return  this.isTrackable() && this.scoredItems > 0;
    };

    v3sSection.prototype.getScoredItemsCount = function () {
        return this.isTrackable() ? this.scoredItems : 0;
    };

    v3sSection.prototype.getExercisesCount = function () {
        return this.isTrackable() ? this.scoredItems : 0;
    };

    v3sSection.prototype.updateExercisesCount = function () {
        var scored = 0;

        if (this.isTrackable()) {
            angular.forEach(this.children, function (item) {
                if (item.isTrackable()) {
                    scored += item.getScoredItemsCount();               
                }
            });
        }

        this.scoredItems = scored;
    };

    v3sSection.prototype.isVisible = function () {
        var visible = this.visible !== false;

        if (visible && this.parent !== null) {
            visible = this.parent.isVisible();
        }

        return visible;
    };

    v3sSection.prototype.getProgress = function (withoutTreeChildren) {
        var progress = { completed: 0, count: 0 };
        if (this.isTrackable()) {
            var items = this.getChildren();
            for (var i = 0; i < items.length; i++) {
                var itemProgress = items[i].getProgress(withoutTreeChildren);
                progress.completed += itemProgress.completed;
                progress.count += itemProgress.count;
            }
        }

        return progress;
    };

    v3sSection.prototype.getItem = function (id) {
        if (!!id) {
            if (!!this.parent && (this.id === id || this.path === id || this.pathMobile === id)) {
                return this;
            }
            for (var i = 0; i < this.children.length; i++) {
                var item = this.children[i];
                if (item.id === id || item.path === id || item.pathMobile === id) {
                    return item;
                } else if (!!item.getItem) {
                    var child = item.getItem(id);
                    if (!!child) {
                        return child;
                    }
                }
            }
        }
        return null;
    };

    v3sSection.prototype.getItemByTag = function (tag) {
        var item = null;

        if (this.hasTag(tag)) {
            item = this;
        } else {
            for (var i = 0; i < this.children.length && !item; i++) {
                if (!!this.children[i].getItemByTag) {
                    item = this.children[i].getItemByTag(tag);
                } else if (this.children[i].hasTag(tag)){
                    item = this.children[i];
                }
            }
        }

        return item;
    };

    v3sSection.prototype.getItemsByType = function (type) {
        var items = [];

        if (!!type) {
            if (this instanceof type) {
                items.push(this);
            } 

            angular.forEach(this.children, function (item) {
                if (!!item.getItemsByType) {
                    items = items.concat(item.getItemsByType(type));
                } else if (item instanceof type) {
                    items.push(item);
                }
            });
        }

        return items;
    };

    v3sSection.prototype.getChildren = function () {
        return this.children;
    };

    v3sSection.prototype.updateTreeDepth = function () {
        v3sItem.prototype.updateTreeDepth.call(this);
        angular.forEach(this.children, function (item, key) {
            item.updateTreeDepth();
        });
    };

    v3sSection.prototype.getFirstChild = function () {
        var first = this.getItem(this.first);
        if (!first) {
            first = this.children[0];
        }
        if (!!first && first.type === "section") {
            first = first.getFirstChild();
        }
        if (!!first && !first.isVisible()) {
            var next = this.getNextChild(first);
            if (!!next && next.isParent(this)) {
                first = next;
            }
        }

        return first;
    };

    v3sSection.prototype.getLastChild = function () {
        var last = this.getItem(this.last);
        if (!last) {
            last = this.children[this.children.length - 1];
        }
        if (!!last && last.type === "section") {
            last = last.getLastChild();
        }
        if (!!last && !last.isVisible()) {
            var previous = this.getPreviousChild(last);
            if (!!previous && previous.isParent(this)) {
                last = previous;
            }

        }
        return last;
    };

    v3sSection.prototype.getPreviousChild = function (item) {
        var itemWithPrevIndex = null;
        if (item.previous === "none") {
            return "none";
        } else {
            itemWithPrevIndex = this.getWbt().getItem(item.previous);

            if (!itemWithPrevIndex) {
                var findChild = false;
                for (var i = this.children.length; i > 0 && !itemWithPrevIndex; i--) {
                    if (this.children[i] === item) {
                        findChild = true;
                    }

                    if (findChild) {
                        var child = this.children[i - 1];
                        if (!!child && child.isVisible()) {
                            itemWithPrevIndex = child;
                        }
                    }
                }
            }

            if (!itemWithPrevIndex && !!this.parent) {
                itemWithPrevIndex = this.parent.getPreviousChild(this);
            }

            if (!!itemWithPrevIndex && !!itemWithPrevIndex.getPath && !itemWithPrevIndex.getPath()) {
                if (!!itemWithPrevIndex.getLastChild && itemWithPrevIndex.children.length > 0) {
                    itemWithPrevIndex = itemWithPrevIndex.getLastChild();
                } else {
                    itemWithPrevIndex = itemWithPrevIndex.getPrevious();
                }    
            }

        }

        return itemWithPrevIndex;
    };

    v3sSection.prototype.getNextChild = function (item) {
        var itemWithNextIndex = null;
        if (item.next === "none") {
            return "none";
        } else {
            itemWithNextIndex = this.getWbt().getItem(item.next);

            if (!itemWithNextIndex) {
                var findChild = false;
                for (var i = 0; i < this.children.length && !itemWithNextIndex; i++) {
                    if (this.children[i] === item) {
                        findChild = true;
                    }
                    if (findChild && i + 1 < this.children.length) {
                        var child = this.children[i + 1];
                        if (!!child && child.isVisible()) {
                            itemWithNextIndex = child;
                        }
                    }
                }
            }

            if (!itemWithNextIndex && !!this.parent) {
                itemWithNextIndex = this.parent.getNextChild(this);
            }

            if (!!itemWithNextIndex && !!itemWithNextIndex.getPath && !itemWithNextIndex.getPath()) {
                if (!!itemWithNextIndex.getFirstChild && itemWithNextIndex.children.length > 0) {
                    itemWithNextIndex = itemWithNextIndex.getFirstChild();
                } else {
                    itemWithNextIndex = itemWithNextIndex.getNext();
                }
            }
        }

        return itemWithNextIndex;
    };

    v3sSection.prototype.setStatus = function (status, options) {
        var changed = false;
        options = options || {};

        if (this.childrenIncludeFilter.indexOf(this.ScormDataEnum.STATUS) == -1 && options.overwrite && (status === "incomplete" || status === "completed")) {
            var childOptions = { overwrite: true, resetOnlyAttempted: true };
            var self = this;
            this.updateChildren(function () {
                angular.forEach(self.getChildren(), function (item) {
                    changed = item.setStatus(status, childOptions) || changed;
                });
            });
        }

        changed = v3sItem.prototype.setStatus.call(this, status, options) || changed;
        return changed;
    };

    v3sSection.prototype.setScore = function (score, options) {
        var changed = false;
        options = options || {};
        score = this.parseScore(score);

        if (this.childrenIncludeFilter.indexOf(this.ScormDataEnum.SCORE) == -1 && options.overwrite && (score == 0 || score == 100)) {
            var childOptions = { overwrite: true, resetOnlyAttempted: true };
            var self = this;
            this.updateChildren(function () {
                angular.forEach(self.getChildren(), function (child) {
                    if (child.isScorable()) {
                        changed = child.setScore(score, childOptions) || changed;
                    }
                });
            });
        }

        changed = v3sItem.prototype.setScore.call(this, score, options) || changed;
        return changed;
    };

    v3sSection.prototype.getExerciseStatus = function () {
        var status = "";

        if (this.isScorable()) {
            if (this.score >= 0 && this.masteryscore >= 0 && this.score >= this.masteryscore) {
                status = "passed";
            } else {
                status = "failed";
            }
        }

        return status;
    };

    v3sSection.prototype.resetData = function () {
        var self = this;
        this.updateChildren(function () {
            angular.forEach(self.children, function (item) {
                item.resetData(true);
            });
        });
        v3sItem.prototype.resetData.call(self);
    };

    v3sSection.prototype.getScormData = function (excludeFilter) {
        //obsolete
    };

    v3sSection.prototype.setScormData = function (data) {
        //obsolete
        v3sItem.prototype.setScormData.call(this, data);

        if (this.children.length > 0) {
            if (!!data && data.length > 1) {
                if (!!data[this.ScormDataEnum.CHILDREN]) {
                    var self = this;
                    this.updateChildren(function () {
                        angular.forEach(self.children, function (child) {
                            child.setScormData(data[self.ScormDataEnum.CHILDREN][child.id]);
                        });
                    });
                }
            }
        }
    };

    v3sSection.prototype.getGlobalScormData = function (data, excludeFilter) {
        v3sItem.prototype.getGlobalScormData.call(this, data, excludeFilter);

        excludeFilter = this.getExcludeFilter(excludeFilter);

        for (var i = 0; i < this.children.length; i++) {
            var child = this.children[i];
            if (!!child) {
                child.getGlobalScormData(data, excludeFilter);
            }
        }
    };

    v3sSection.prototype.setGlobalScormData = function (data) {
        v3sItem.prototype.setGlobalScormData.call(this, data);

        if (!!data) {
            var self = this;
            this.updateChildren(function () {
                angular.forEach(self.children, function (child) {
                    child.setGlobalScormData(data);
                });
            });
        }
    };

    v3sSection.prototype.getExcludeFilter = function (excludeFilter) {
        excludeFilter = !!excludeFilter? excludeFilter.concat([]) : [];

        if (this.isCompleted()) {
            excludeFilter.push(this.ScormDataEnum.STATUS);
        }
        if (this.score == 0 || this.score == 100) {
            excludeFilter.push(this.ScormDataEnum.SCORE);
        }

        var childrenIncludeFilter = this.childrenIncludeFilter;
        excludeFilter = excludeFilter.filter(function (element) {
            return childrenIncludeFilter.indexOf(element) === -1;
        });

        return excludeFilter;
    };

    v3sSection.prototype.getChangeCount = function () {
        var count = v3sItem.prototype.getChangeCount.call(this);

        for (var i = 0; i < this.children.length; i++) {
            var child = this.children[i];
            if (!!child) {
                count += child.getChangeCount();
            }
        }

        return count;
    };

    v3sSection.prototype.resetChangeCount = function () {
        v3sItem.prototype.resetChangeCount.call(this);

        for (var i = 0; i < this.children.length; i++) {
            var child = this.children[i];
            if (!!child) {
                child.resetChangeCount();
            }
        }
    };

    return v3sSection;
}]);